import { NotificationService } from './../../../common/services/notification/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PreloaderService } from './../../../common/services/preloader/preloader.service';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  CREATE_CUSTOMER_ADDRESS_REQUESTED,
  FETCH_CUSTOMER_DETAIL_REQUESTED,
  FETCH_CUSTOMER_DETAIL_SUCCEEDED,
  FETCH_CUSTOMER_PAYMENT_DETAIL_REQUESTED,
  FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED,
  FETCH_CUSTOMER_ADDRESSES_REQUESTED,
  FETCH_CUSTOMER_ADDRESSES_SUCCEEDED,
  DELETE_CUSTOMER_ADDRESS_REQUESTED,
  DELETE_CUSTOMER_ADDRESS_SUCCEEDED,
  UPDATE_CUSTOMER_ADDRESS_SUCCEEDED,
  UPDATE_CUSTOMER_ADDRESS_REQUESTED,
  UPDATE_CUSTOMER_REQUESTED,
  UPDATE_CUSTOMER_SUCCEEDED,
  CREATE_CUSTOMER_ADDRESS_SUCCEEDED,
  SET_DEFAULT_ADDRESS_REQUESTED,
  SET_DEFAULT_ADDRESS_SUCCEEDED,
  DELETE_CUSTOMER_SUCCEEDED,
  DELETE_CUSTOMER_REQUESTED,
  FETCH_SELLER_PRODUCTS_REQUESTED,
  FETCH_SELLER_PRODUCTS_SUCCESSED,
  FETCH_USER_WISHLIST_REQUESTED,
  FETCH_USER_WISHLIST_SUCCESSED,
  FETCH_WISHLIST_DETAIL_REQUESTED,
  FETCH_WISHLIST_DETAIL_SUCCESSED,
  FETCH_ALL_PRODUCTS_REQUESTED,
  FETCH_ALL_PRODUCTS_SUCCESSED,
  CREATE_WISHLIST_REQUESTED,
  CREATE_WISHLIST_SUCCESSED,
  REMOVE_PRODUCT_FROM_WISHLIST_SUCCESSED,
  REMOVE_PRODUCT_FROM_WISHLIST_REQUESTED,
  UPDATED_WISHLIST_REQUESTED,
  UPDATED_WISHLIST_SUCCESSED,
  UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED,
  UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED,
  FETCH_USER_CHECKOUT_REQUESTED,
  FETCH_USER_CHECKOUT_SUCCEEDED,
  FETCH_USER_WALLET_SUCCEEDED,
  FETCH_USER_WALLET_REQUESTED,
  DEBIT_WALLET_REQUESTED,
  DEBIT_WALLET_SUCCEEDED,
  CREDIT_WALLET_SUCCEEDED,
  CREDIT_WALLET_REQUESTED,
  GENERATE_COUPON_REQUESTED,
  GENERATE_COUPON_SUCCEEDED
} from './edit.actions';
import { put } from 'redux-saga/effects';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import * as _ from 'lodash';
import addressesSaga from './addresses/addresses.saga';
import offerSaga from './offers-made/offers-made.saga';
import { REMOVE_OFFER_REQUESTED, REMOVE_OFFER_SUCCESSED } from './offers-made/offers-made.actions';
import { DELIVERY_COMP } from '../../delivery/delivery.const';
import { delay } from 'redux-saga';

function* createCustomerAddress(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.customerAddress.create(action.data).toPromise();
    yield put({ type: CREATE_CUSTOMER_ADDRESS_SUCCEEDED, data: result });
    if (action.com === DELIVERY_COMP) {
    } else {
      AppInjector.get(Router).navigate([`/customer/edit/${action.data.user_id}/addresses`]);
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    AppInjector.get(Router).navigate([`/customer/edit/${action.data.user_id}/addresses`]);
  }
}

function* watchCreateCustomerAddressRequest() {
  yield takeEvery(CREATE_CUSTOMER_ADDRESS_REQUESTED, createCustomerAddress);
}

function* getCustomer(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.user.getItemById(action.data).toPromise();
    yield put({ type: FETCH_CUSTOMER_DETAIL_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchCustomerDetailRequest() {
  yield takeEvery(FETCH_CUSTOMER_DETAIL_REQUESTED, getCustomer);
}

function* getCustomerPayment(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.user.getItemById(action.data).toPromise();
    yield put({ type: FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchCustomerPaymentRequest() {
  yield takeEvery(FETCH_CUSTOMER_PAYMENT_DETAIL_REQUESTED, getCustomerPayment);
}

function* getCustomerAddresses(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.customerAddress.get(action.data.pagination, { id: '' }, action.data.filter).toPromise();
    yield put({
      type: FETCH_CUSTOMER_ADDRESSES_SUCCEEDED,
      data: results.items
    });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchCustomerAddressesRequest() {
  yield takeEvery(FETCH_CUSTOMER_ADDRESSES_REQUESTED, getCustomerAddresses);
}

function* deleteAddress(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.customerAddress.delete(action.data.id).toPromise();
    yield put({ type: DELETE_CUSTOMER_ADDRESS_SUCCEEDED, data: action.data });
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('success', 'Address deleted', 3000);
    AppInjector.get(Router).navigate([`/customer/edit/${action.data.user_id}/addresses`]);
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
    AppInjector.get(Router).navigate([`/customer/edit/${action.data.user_id}/addresses`]);
  }
}

function* watchDeleteCustomerAddressRequest() {
  yield takeEvery(DELETE_CUSTOMER_ADDRESS_REQUESTED, deleteAddress);
}

function* updateAddress(action) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.customerAddress.update(action.data).toPromise();
    yield put({ type: UPDATE_CUSTOMER_ADDRESS_SUCCEEDED, data: result });
    AppInjector.get(NotificationService).show('success', 'Update customer address sucess', 3000);
    yield put({
      type: FETCH_CUSTOMER_ADDRESSES_REQUESTED,
      data: {
        pagination: this.getQuery(),
        filter: { user_id: this.activatedRoute.parent.snapshot.params.id }
      }
    });
    // yield delay(2000);
    // if (action.com === DELIVERY_COMP) {
    // } else {
    // }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    AppInjector.get(Router).navigate([`/customer/edit/${action.userId}/addresses`]);
  }
}

function* watchUpdateCustomerAddressRequest() {
  yield takeEvery(UPDATE_CUSTOMER_ADDRESS_REQUESTED, updateAddress);
}

function* updateCustomer(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.user.update(action.data).toPromise();
    yield put({ type: UPDATE_CUSTOMER_SUCCEEDED, data: result });
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('success', 'Customer updated', 3000);
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateCustomerRequest() {
  yield takeEvery(UPDATE_CUSTOMER_REQUESTED, updateCustomer);
}

function* updateCustomerPaymentDetail(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.user.updatePaymentDetail(action.data).toPromise();
    yield put({ type: UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED, data: result.customer });
    AppInjector.get(PreloaderService).hide();
    AppInjector.get(NotificationService).show('success', 'Customer payment detail updated', 3000);

  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateCustomerPaymentDetailRequest() {
  yield takeEvery(UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED, updateCustomerPaymentDetail);
}

function* deleteCustomer(action) {
  try {
    AppInjector.get(PreloaderService).show();
    const result = yield AppInjector.get(ApiService).user.delete(action.data).toPromise();
    if (!_.isUndefined(action.com)) {
      yield put({
        type: DELETE_CUSTOMER_SUCCEEDED,
        com: action.com,
        data: result
      });
      AppInjector.get(NotificationService).show('success', 'Customer Deleted', 3000);
      AppInjector.get(Router).navigate(['/customer']);
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteCustomerRequest() {
  yield takeEvery(DELETE_CUSTOMER_REQUESTED, deleteCustomer);
}

function* getSellerProduct(action) {
  try {
    const results = yield AppInjector.get(ApiService).product.get(action.data.pagination, action.data.sorts, action.data.filters).toPromise();
    yield put({ type: FETCH_SELLER_PRODUCTS_SUCCESSED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchSellerProductRequest() {
  yield takeEvery(FETCH_SELLER_PRODUCTS_REQUESTED, getSellerProduct);
}

function* getUserWishlist(action) {
  try {
    const results = yield AppInjector.get(ApiService).wishlist.get(action.data.pagination, action.data.sorts, action.data.filters).toPromise();
    yield put({ type: FETCH_USER_WISHLIST_SUCCESSED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchUserWishlistRequest() {
  yield takeEvery(FETCH_USER_WISHLIST_REQUESTED, getUserWishlist);
}

function* getUserCheckout(action) {
  try {
    const result = yield AppInjector.get(ApiService).checkout.getCheckoutByUserId(action.data).toPromise();
    yield put({ type: FETCH_USER_CHECKOUT_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchUserCheckoutRequest() {
  yield takeEvery(FETCH_USER_CHECKOUT_REQUESTED, getUserCheckout);
}

function* getWishlist(action) {
  try {
    const result = yield AppInjector.get(ApiService).wishlist.getItemByUserIdAndProductId(action.data.user_id, action.data.product_id).toPromise();
    yield put({ type: FETCH_WISHLIST_DETAIL_SUCCESSED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchWishlistDetailRequest() {
  yield takeEvery(FETCH_WISHLIST_DETAIL_REQUESTED, getWishlist);
}

function* getAllProduct(action) {
  try {
    const results = yield AppInjector.get(ApiService).product.list().toPromise();
    yield put({ type: FETCH_ALL_PRODUCTS_SUCCESSED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllProductRequest() {
  yield takeEvery(FETCH_ALL_PRODUCTS_REQUESTED, getAllProduct);
}

function* createWishlist(action) {
  try {
    const result = yield AppInjector.get(ApiService).wishlist.create(action.data).toPromise();

    if (result) {
      yield put({ type: CREATE_WISHLIST_SUCCESSED, data: result });
      AppInjector.get(Router).navigate([`customer/edit/${action.data.user_id}/wishlist`]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateWishlistRequest() {
  yield takeEvery(CREATE_WISHLIST_REQUESTED, createWishlist);
}

function* removeProductFromWishlist(action) {
  try {
    const result = yield AppInjector.get(ApiService).wishlist.deleteByUserIdAndProductId(action.data).toPromise();
    if (result) {
      yield put({ type: REMOVE_PRODUCT_FROM_WISHLIST_SUCCESSED, data: result });
      AppInjector.get(Router).navigate([`customer/edit/${action.data.user_id}/wishlist/`]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRemoveProductFromWishlistRequest() {
  yield takeEvery(REMOVE_PRODUCT_FROM_WISHLIST_REQUESTED, removeProductFromWishlist);
}

// function* watchFetchWishlistDetailSuccess() {
//   yield takeLatest(FETCH_WISHLIST_DETAIL_SUCCESSED, getAllProduct);
// }

function* updateWishlist(action) {
  try {
    const result = yield AppInjector.get(ApiService).wishlist.updateByUserIdAndProductId(action.data).toPromise();
    yield put({ type: UPDATED_WISHLIST_SUCCESSED, data: result });
    AppInjector.get(NotificationService).show('success', 'Wishlist updated', 3000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateWishlistRequest() {
  yield takeEvery(UPDATED_WISHLIST_REQUESTED, updateWishlist);
}

function* deleteOffer(action) {
  try {
    const result = yield AppInjector.get(ApiService).offers.delete(action.data).toPromise();
    if (result) {
      yield put({ type: REMOVE_OFFER_SUCCESSED, data: result });
      AppInjector.get(Router).navigate([`customer/edit/${action.user_id}/offers-made`]);
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchRemoveOfferRequest() {
  yield takeEvery(REMOVE_OFFER_REQUESTED, deleteOffer);
}

function* getWallet(action) {
  try {
    const result = yield AppInjector.get(ApiService).user.getWallet(action.data).toPromise();
    yield put({ type: FETCH_USER_WALLET_SUCCEEDED, data: result });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetWalletRequest() {
  yield takeEvery(FETCH_USER_WALLET_REQUESTED, getWallet);
}

function* debitWallet(action) {
  try {
    const result = yield AppInjector.get(ApiService).user.debitWallet(action.user_id, action.amount, action.note).toPromise();
    yield put({ type: DEBIT_WALLET_SUCCEEDED, data: result });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  }
}

function* watchDebitWalletRequest() {
  yield takeEvery(DEBIT_WALLET_REQUESTED, debitWallet);
}

function* creditWallet(action) {
  try {
    const result = yield AppInjector.get(ApiService).user.creditWallet(action.user_id, action.amount, action.note).toPromise();
    yield put({ type: CREDIT_WALLET_SUCCEEDED, data: result });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  }
}

function* watchCreditWalletRequest() {
  yield takeEvery(CREDIT_WALLET_REQUESTED, creditWallet);
}

function* generateCoupon(action) {
  try {
    const result = yield AppInjector.get(ApiService).user.generateCoupon(action.user_id).toPromise();
    yield put({ type: GENERATE_COUPON_SUCCEEDED, data: result });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
    yield put({ type: FETCH_USER_WALLET_REQUESTED, data: action.user_id });
  }
}

function* watchGenerateCouponRequest() {
  yield takeEvery(GENERATE_COUPON_REQUESTED, generateCoupon);
}

export default [
  ...addressesSaga,
  ...offerSaga,
  watchCreateCustomerAddressRequest,
  watchFetchCustomerDetailRequest,
  watchFetchCustomerPaymentRequest,
  watchFetchCustomerAddressesRequest,
  watchDeleteCustomerAddressRequest,
  watchUpdateCustomerAddressRequest,
  watchUpdateCustomerRequest,
  watchDeleteCustomerRequest,
  watchFetchSellerProductRequest,
  watchFetchUserWishlistRequest,
  watchFetchWishlistDetailRequest,
  watchFetchAllProductRequest,
  watchCreateWishlistRequest,
  watchRemoveProductFromWishlistRequest,
  watchUpdateWishlistRequest,
  watchRemoveOfferRequest,
  watchUpdateCustomerPaymentDetailRequest,
  watchFetchUserCheckoutRequest,
  watchGetWalletRequest,
  watchDebitWalletRequest,
  watchCreditWalletRequest,
  watchGenerateCouponRequest
];
